import * as types from "../actionTypes";

export const setHiringPlanAverageByYear = (key, yearKey, amount) => {
  return (dispatch) => {
    return dispatch({
      type: types.SET_HIRING_PLAN_AVERAGE_BY_YEAR,
      key,
      yearKey,
      amount,
    });
  };
};

export const setHiringPlanAverageByMonth = (key, yearKey, amount) => {
  return (dispatch) => {
    return dispatch({
      type: types.SET_HIRING_PLAN_AVERAGE_BY_MONTHS,
      key,
      yearKey,
      amount,
    });
  };
};
//

export const replaceHiringPlanAverageYears = (key, payload) => {
  return (dispatch) => {
    return dispatch({
      type: types.REPLACE_HIRING_PLAN_AVERAGE_YEARS,
      key,
      payload,
    });
  };
};

export const resetHiringPlanAverageReducer = () => {
  return (dispatch) => {
    return dispatch({
      type: types.RESET_HIRING_PLAN_AVERAGE_REDUCER,
    });
  };
};
